import React from 'react';
import classNames from 'classnames';
import View from '@loggi/ui/components/view';

function getViewContainerElement(
  otherProps,
  classList,
  className,
  style,
  rowClassName,
  rowStyle,
  children
) {
  const classes = classNames(classList, className);
  return (
    <View {...otherProps} className={classes} style={style}>
      <View className={classNames('row', rowClassName)} style={rowStyle}>
        {children}
      </View>
    </View>
  );
}

export { getViewContainerElement };
